const s = {
  name: "Taxi",
  dimensions: { width: 40, height: 36 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 36" style="enable-background:new 0 0 40 36;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M15,27h10v-2H15V27z"/>
		<path class="st0" d="M8,22c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3C9.3,25,8,23.7,8,22z M11,21c-0.6,0-1,0.4-1,1
			c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1C12,21.4,11.6,21,11,21z"/>
		<path class="st0" d="M29,19c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3s3-1.3,3-3C32,20.3,30.7,19,29,19z M28,22c0-0.6,0.4-1,1-1s1,0.4,1,1
			c0,0.6-0.4,1-1,1S28,22.6,28,22z"/>
		<path class="st0" d="M15,0h10v5h4.7l3.1,10H33c1.7,0,3,1.4,3,3v0l-0.1,9.9v0c0,1.3-0.8,2.4-1.9,2.8V36h-8v-5.1H14V36H6v-5.3
			c-1.1-0.4-1.9-1.5-1.9-2.8l0,0L4,18l0,0c0-1.7,1.3-3,3-3h0.3l3.1-10H15V0z M23,2h-6v3h6V2z M11.8,7l-2.5,8h21.3l-2.5-8H11.8z
			 M7,17c-0.6,0-1,0.4-1,1v0l0,9.9l0,0c0,0.6,0.5,1,1,1h24.9v0h1c0.6,0,1-0.4,1-1v0L34,18l0,0c0-0.5-0.4-1-1-1H7z M8,34h4v-3H8V34z
			 M28,34h4v-3h-4V34z"/>
		<path class="st0" d="M0,22v-6h2v6H0z"/>
		<path class="st0" d="M40,16h-2v6h2V16z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Taxi
};
